<div class="container-fluid">
    <div class="row">
        <div class="col-sm-12">
            <div class="card-body">
                <div class="container" *ngIf="lote?.id_estado === 3">
                    <div class="alert text-center py-4 shadow-sm" style="background: white;">

                        <div class="mb-3 d-flex justify-content-center">
                            <lottie-player src="/assets/lottie/contractsign.json" background="transparent" speed="0.5"
                                loop autoplay style="width:300px;height:300px"></lottie-player>
                        </div>

                        <h3 class="fw-bold">Firma completa</h3>
                        <p class="mb-4">Este documento ha sido completado.</p>
                        <button class="btn btn-primary rounded-pill px-4 py-2" (click)="volverInicio()">
                            <i class="fa-solid fa-house me-2"></i>
                            Volver al inicio
                        </button>

                    </div>
                </div>
                <ng-container>
                    <app-stepper-component [steps]="3" [step]="stepActual" (stepChanged)="onStepChange($event, 'NEXT')"
                        [icons]="['fa-solid fa-upload', 'fa-solid fa-arrow-pointer', 'fa-solid fa-pencil']" [animation]="animationArray"
                        [dato_evaluado]="'INC'" [dato_evaluar]="short_estado_lote"
                        *ngIf="userModule && lote?.id_estado != 3" [nameStepers]="['Subida de Archivo', 'Selección de Firma', 'Firma']">

                        <ng-template>
                            <form [formGroup]="batchConfigForm" *ngIf="masarchvios">
                                <div class="form-floating mb-3">
                                    <input #tituloInput id="title" type="text" formControlName="titulo" class="form-control" autofocus />
                                    <label for="title">Nombre de firma</label>

                                    <div class="col-md-12">
                                        <span class="text-danger"
                                            *ngIf="(batchConfigForm.get('titulo')?.touched) && batchConfigForm.get('titulo')?.errors?.['required']">
                                            El nombre de la firma es requerido.
                                        </span>
                                    </div>
                                </div>
                            </form>
                            <subida-documento-simple-component (primerPaso)="onStepChange($event, '')"
                                (archivo)="obtenerArchivo($event)"></subida-documento-simple-component>
                        </ng-template>
                        <ng-template>
                            <asociacion-firma-simple data-tour="areas-firma-root"
                                (segundoPaso)="onStepChange($event, 'AUTO')"></asociacion-firma-simple>
                        </ng-template>
                        <ng-template>
                            <app-solicitud-firma
                                (estadoUltimaEtapa)="validateUltimaEtapaF($event)"></app-solicitud-firma>
                        </ng-template>
                    </app-stepper-component>
                </ng-container>
            </div>

            <div class="container" *ngIf="!userModule">
                <div class="alert text-center py-4 shadow-sm" style="background: white;">

                    <div class="mb-3 d-flex justify-content-center">
                        <lottie-player src="/assets/lottie/wrong.json" background="transparent" speed="0.5" loop
                            autoplay style="width:300px;height:300px"></lottie-player>
                    </div>

                    <h3 class="fw-bold">Acceso limitado</h3>
                    <p class="mb-4">No tienes permisos para ver este recurso</p>

                    <button class="btn btn-primary rounded-pill px-4 py-2" (click)="volverInicio()">
                        <i class="fa-solid fa-house me-2"></i>
                        Volver al inicio
                    </button>

                </div>
            </div>
        </div>
    </div>
</div>